import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';
import { WavePaymentInfo } from '../models/wavePaymentInfo.model';
import { environment } from '../environments/environment';
import { WavePayoutInfo } from '../models/wavePayoutInfo.model';
@Injectable({
  providedIn: 'root'
})
export class WaveService {

  constructor(private http: HttpClient) { }


  saveOrderByWavePayment(wavePaymentInfo: WavePaymentInfo){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.post<any>(`${environment.url}/wave/payWithWave/`, wavePaymentInfo,{'headers': headers});
  }

  // Reversement par wave
  reversementByWaveDigitalMonney(KahpooReverse: number) {
    return this.http.post<any>(`${environment.url}/wave/reverseWithWave`, KahpooReverse);
  }

  // Retourne la balance du compte wave
  getWaveRetailerBalance() {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<any>(`${environment.url}/wave/balance`, { headers: headers });
  }

  // Renvoie une liste des transactions de votre compte pour un jour donné.
  returnWaveTransactions(date?: string): Observable<any> {
    let headers = new HttpHeaders();
    const sessionId = localStorage.getItem("kapo_session_id");
    if (sessionId) {
      headers = headers.set('kapo_session_id', sessionId);
    }

    let url = `${environment.url}/wave/transactions`;
    if (date) {
      url += `?date=${date}`;
    }

    return this.http.get<any>(url, { headers });
  }



}
